<template>
	<v-row
		dense
		no-gutters
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card outlined>
			
				<v-card-text>
					<v-row>
						
						<v-col 
							cols 	= "12"
							lg 		= "8"
							md 		= "12"
							v-show 	= "show.add"
						>
							<v-card 
								outlined
							>
								<v-card-title
									class = "pa-0 pl-1  primary body-2 white--text"
								>

									<v-icon
										small
										color = "white"
										class  = "mx-1"
									>
										mdi-account-multiple-plus
									</v-icon>
									<span
									>
										{{ sub_title }}										
									</span>
									
									<v-spacer></v-spacer>
									<v-btn
										x-small
										color="info"
										class="mr-2"
										@click="exportPermissionPreset"
									>
										<v-icon x-small class="mr-1">mdi-download</v-icon>
										Export preset
									</v-btn>
									<v-btn
										x-small
										color="warning"
										class="mr-2"
										@click="openPermissionPresetImport"
									>
										<v-icon x-small class="mr-1">mdi-upload</v-icon>
										Import preset
									</v-btn>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<v-row
									no-gutters
									justify = "center"
									align 	= "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										
									>			
									<!-- v-if  = "item_field.enable"			 -->
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text' || item_field.type == 'number' || item_field.type == 'password' "
												v-model 	 = "info[item_field.key]"
												:label  	 = "$ml.get(item_field.text)"
												:type 		 = "item_field.type"
												class 		 = "mt-2"
												v-show 		 = "item_field.enable"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
												@click 		 = "$Helper.keyboard_is_active(item_field.key, ID_notification, 'obj', 'info', info[item_field.key])"	
											></v-text-field>
												<!-- @input 	= "v => { v = input[item_field.key] }" -->
												<!-- :disabled = "item_field.enable"								 -->
												<!-- @input  = "v => { info[item_field.key] = v.toUpperCase()}"		 -->
											
											<v-select
												dense
												outlined
												hide-details
												v-if 		= "item_field.type == 'select'"
												v-show 		= "item_field.enable"												
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												:item-text  = "item_field.item_text"
												:item-value = "item_field.value" 
												class 		= "my-2"
											>
												<!-- @input 		= "render_input(item_field.key)" -->
												<!-- return-object -->
												<!-- multiple -->
												<template v-slot:selection="{ item, index }">
											        <v-chip x-small 
											        	v-if = "index < 3">
											          <span>{{ item }}</span>
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
								          (+{{ info[item_field.key].length - 3 }} {{ $ml.get('others') }})
											        </span>
											      </template>
											</v-select>
										</v-col>
									</template>
								</v-row>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>

									<v-progress-circular
								      	indeterminate
								      	color  = "primary"
								      	v-show = "show_progress"
								    	:size  = "20"
								    	:width = "4"
								    ></v-progress-circular>

									<v-btn
										x-small
										v-show 		= "!show_progress"
										color  		= "primary"										
										@click 		= "actions(btn_action)"
										:disabled 	= "!required_info"
									>
										{{ $ml.get(btn_action) }}
									</v-btn>
									<!-- <v-btn
										x-small
										color 	  =  "error"
										:disabled = "btn_action == 'update' ? false : true"
										v-text    = "$ml.get('delete')"						
										@click    = "actions('confirm_delete')"
									></v-btn> -->
								</v-card-actions>
							</v-card>
							<v-divider class = "my-1"></v-divider>
							<template
							v-show = "show.add"
						>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "blue-grey darken-1 white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table_dev)}}
					    		</v-toolbar-title>
					    		<v-spacer></v-spacer>
					    		<template
						    		v-for 	= "(btn_permission, idx_permission) of btn_options_permissions"
					    		>
					    			
						    		<v-tooltip
						    			bottom
						    		>
						    			<template
						    				v-slot:activator = "{ on }"
						    			>
						    				<v-btn
						    					fab
						    					x-small
						    					:key 	= "idx_permission + 'btn_permission'"
						    					:color 	= "btn_permission.color"
						    					@click  = "actions(btn_permission.action, btn_permission)"
						    					v-on	= "on"
						    					height  = "20"
						    					width 	= "20"
						    					v-show 	= "show[btn_permission.key]"
						    					:class 	= "btn_permission.class"

						    				>
						    					<v-icon
						    						x-small
						    					>					    					
						    						{{ btn_permission.icon }}
						    					</v-icon>
						    				</v-btn>
						    			</template>
						    			<span>
						    				{{ btn_permission.text }}
						    			</span>
						    		</v-tooltip>
					    		</template>
					    			
					    	</v-toolbar>
							<v-card 
								outlined
								v-show 	= "show.show_add_permission"

							>
								<v-card-title
									class = "pa-0 primary body-2"
								>
									<v-icon
										x-small
										fab
										color = "white"
										class = "mx-1"
									>
										mdi-lock-open-plus
									</v-icon>
									<span>
										{{ $ml.get("add_permission") }}
									</span>

								</v-card-title>
								<v-card-text
								>
									<v-row
										no-gutters
										justify = "center"
										align 	= "center"
									>	
										<template
											v-for = "(item_permission_field, idx_permission_field) of info_permissions_fields "
											
										>			
										<!-- v-if  = "item_permission_field.enable"			 -->
											<v-col 
												:cols 	= "item_permission_field.cols"
												:key 	= "idx_permission_field"
											>
												<v-text-field
													dense
													outlined
													hide-details
													v-if 		 = "['text', 'number'].includes(item_permission_field.type)"
													v-model 	 = "info_permission[item_permission_field.key]"
													:label  	 = "item_permission_field.text"
													:type 		 = "item_permission_field.type"
													class 		 = "mt-2"													
													:placeholder = "item_permission_field.placeholder ? $ml.get(item_permission_field.placeholder) : ''"
													@click 		 = "$Helper.keyboard_is_active(item_permission_field.key, ID_notification, 'obj', 'info', info_permission[item_permission_field.key])"	
												></v-text-field>
												<v-card 
													outlined 
													class 		= "pa-0 caption pb-1 pl-1 mt-1" 
													height 		= "40"																			
													v-else-if 	= "item_permission_field.type == 'switch'">
													<v-switch			
														dense						
														hide-details
														class 			= "mt-1"			
														v-model 		= "info_permission[item_permission_field.key]"									
														:label 			= "item_permission_field.text"
														:prepend-icon 	= "item_permission_field.icon"
														:true-value 	= "item_permission_field.value"
													></v-switch>
														
												</v-card>
											</v-col>
										</template>
									</v-row>
								</v-card-text>
								<v-card-actions>
									<v-btn
										x-small
										color 	= "primary"
										@click 	= "actions('save_permission')" 
									>
										{{ $ml.get("save") }}
									</v-btn>
								</v-card-actions>
							</v-card>
							<v-divider></v-divider>

							    <!-- show-select -->
							<v-data-table
								dense
							    fixed-body
							    fixed-header
							    hide-default-footer
								class 				 = "elevation-1 permission-matrix"
								:key                 = "permission_matrix_render_key"
								:items 				 = "permissions"
								:headers 			 = "header_table_dev"
								:group-by 			 = "['permission_group_key']"
								:options.sync 		 = "options_dev"
							   	:server-items-length = "total_dev"
							    :loading-text 		 = "$ml.get('loading_please_wait')"
							   	:loading 			 = "loading_dev"
							    item-key 			 = "permission_item_key"
							    :height  			 = "permission_table_height"
							    :items-per-page 	 = "-1"
							   	:footer-props  		 = "{
							   		// showFirstLastPage 	: true,
							   		itemsPerPageOptions : [/*15, 30*/],
							   		showCurrentPage 	: false,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
								<template v-slot:header.name>
									{{ $ml.get('permission_matrix_resource') }}
								</template>
								<template v-slot:header.can_view>
									{{ $ml.get('can_view') }}
								</template>
								<template v-slot:header.can_add>
									{{ $ml.get('can_add') }}
								</template>
								<template v-slot:header.can_edit>
									{{ $ml.get('can_edit') }}
								</template>
								<template v-slot:header.can_delete>
									{{ $ml.get('can_delete') }}
								</template>
								<template v-slot:header.actions>
									{{ $ml.get('actions') }}
								</template>
								<template v-slot:top >
									<v-text-field
								 		dense
								 		outlined
								 		hide-details
								 		v-model 			= "search_permission"
								 		:label 				= "$ml.get('search')"
								 		prepend-inner-icon 	= "mdi-magnify"
								 		class 				= "my-1"
								 	></v-text-field>
								</template>
								<template v-slot:item.name = "{ item }">
									<div class="permission-suboption py-2">
										<div class="font-weight-medium permission-suboption__title d-flex align-center">
											<v-icon x-small color="blue-grey lighten-3" class="mr-2">{{ item.permission_icon }}</v-icon>
											<span>{{ getPermissionLabel(item) }}</span>
										</div>
										<div class="caption grey--text text--lighten-1 permission-suboption__description">
											{{ getPermissionDescription(item) }}
										</div>
									</div>
								</template>
								<template v-slot:group.header = "{ group, headers, toggle, isOpen }">
									<td :colspan="headers.length" class="permission-module-row blue-grey darken-3 white--text py-2">
										<div class="d-flex align-center">
									<v-btn icon small dark @click="toggle" class="mr-1">
										<v-icon small>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
									</v-btn>
									<v-icon small color="white" class="mr-2">{{ getPermissionGroupIcon(group) }}</v-icon>
									<span class="font-weight-bold permission-module-row__title">{{ getPermissionModuleMeta(group).label }}</span>
									<span class="caption grey--text text--lighten-2 ml-2">{{ $ml.get('permission_matrix_resource') }}</span>
									<v-spacer></v-spacer>
									<v-btn
										x-small
										:color="isPermissionGroupFullyEnabled(group) ? 'error' : 'success'"
										:disabled="!canTogglePermissionGroup(group)"
										@click.stop="togglePermissionGroup(group)"
									>
										<v-icon x-small class="mr-1">{{ isPermissionGroupFullyEnabled(group) ? 'mdi-close' : 'mdi-check-all' }}</v-icon>
										{{ isPermissionGroupFullyEnabled(group) ? $ml.get('off') : $ml.get('on') }}
									</v-btn>
										</div>
								</td>
							</template>
								<template 
									v-for = "item_permission of permission_options"
									v-slot:[`item.${item_permission}`]="{ item, index }" 
								>

									<v-btn
										x-small
										:color  = "item[item_permission] ? 'success' : 'error'"
										:disabled = "isPermissionToggleDisabled(item, item_permission)"
										:class = "{ 'permission-toggle--disabled': isPermissionToggleDisabled(item, item_permission) }"
										@click  = "actions(head.action_table_permission, item, item_permission)"
									>
										<v-icon x-small>{{ item[item_permission] ? 'mdi-check' : 'mdi-close' }}</v-icon>
									</v-btn>	
								</template>
								<template v-slot:item.actions = "{ item }"  >
									<!-- <v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										
									>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn>	 -->
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete_dev', item)"										
									>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
							</v-data-table>
							    <!-- v-model 			 = "selection_devices" -->
						</template>
						</v-col>
						
						<v-col
							cols = "12"
							:lg = "show.add ? 4 : 12"
							md = "12"
						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table)}}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height = "25"
					    				:color  = "!show.add ? 'primary' : 'error'"
					    				@click = "actions('show')"

					    			>
					    				<v-icon>

					    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
					    				</v-icon>
					    			</v-btn>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							    :loading-text 		 = "$ml.get('loading_please_wait')"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
							<template v-slot:item.actions = "{ item }"  >
								<v-btn
									x-small
									color  = "primary"
									@click = "actions('edit', item)"
									v-show = "canEditRoles && item.name != 'SuperAdmin'"
								>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn>	
								<v-btn
									x-small
									color  = "error"
									@click = "actions('confirm_delete', item)"
									v-show = "canDeleteRoles && item.name != 'SuperAdmin'"
								>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.createdAt = "{ item }" >								
									{{ item.date }} 
								</template>
								<template v-slot:item.manager_id = "{ item }" >
									<v-chip 
										x-small
										:color = "!item.manager_id ? 'secondary' : 'success'"
									>
										<span>											
											{{ item.manager_id ? item.manager_id : $ml.get('data_no_found') }} 
										</span>
									</v-chip>
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
					<input
						ref="permissionPresetInput"
						type="file"
						accept="application/json,.json"
						class="d-none"
						@change="handlePermissionPresetFile"
					/>
					<v-dialog v-model="permission_preset.show_preview" max-width="900">
						<v-card>
							<v-card-title class="primary white--text body-1">
								<v-icon small color="white" class="mr-2">mdi-file-import</v-icon>
								Permission preset preview
							</v-card-title>
							<v-card-text class="pt-3">
								<div class="body-2 mb-2">
									<strong>{{ permission_preset.name }}</strong>
								</div>
								<v-alert dense outlined type="info" class="mb-3">
									Create: {{ permission_preset.preview.create }} · Update: {{ permission_preset.preview.update }} · Skipped: {{ permission_preset.preview.skip }}
								</v-alert>
								<v-simple-table dense class="permission-preset-preview">
									<thead>
										<tr>
											<th>Role</th>
											<th>Permission</th>
											<th>Action</th>
											<th>View</th>
											<th>Add</th>
											<th>Edit</th>
											<th>Delete</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(operation, idx) in permission_preset.operations" :key="idx">
											<td>{{ operation.roleName }}</td>
											<td>{{ operation.name }}</td>
											<td>{{ operation.action }}</td>
											<td>{{ operation.can_view ? '✓' : '×' }}</td>
											<td>{{ operation.can_add ? '✓' : '×' }}</td>
											<td>{{ operation.can_edit ? '✓' : '×' }}</td>
											<td>{{ operation.can_delete ? '✓' : '×' }}</td>
										</tr>
									</tbody>
								</v-simple-table>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn x-small text @click="permission_preset.show_preview = false">Cancel</v-btn>
								<v-btn
									x-small
									color="success"
									:loading="permission_preset.loading"
									:disabled="permission_preset.preview.create + permission_preset.preview.update <= 0"
									@click="applyPermissionPreset"
								>
									Apply preset
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'
	import default_parameters from '@/components/general_parameters/default_parameters.js'
	export default{
		name : 'roles',
		data : (vm) => ({
			info 			: {},
			info_permission : {},
			input 			: {},
			head 			: {
				title  					: 'roles',
				// title1 				: 'lpr',
				table  					: 'registered_roles',
				table_dev 				: 'registered_permissions',
				action_table_permission : 'change_value_permission',
			}, 
			info_fields : [
 				{
					key  : 'name',
					text : 'role',
					type : 'text',
					// list : ['cloud','module', 'streaming', 'guardian_cloud', 'external_client'],
					enable : true,
					/*value  : '',
					item_text   : ''*/
 				},
				
				

				

			],
			show 			: {
				add 					: false,
				add_permission  		: true,
				show_add_permission  	: false,
				unlisted_permissions 	: true,
			},
			sub_title 		: vm.$ml.get('register'),			
			show_progress 	: false,
			btn_action 	  	: 'save',

			options 	  			: { },
			total 		  			: 0,
			layout_height 			: 400,
			ID_notification 		: 'listing_details',
			loading 	  			: false,
			list_lists 	  			: [],
			list 		  			: [], 
			required_info 			: true,
			list_profiles 			: [],
			bus 		  			: {},
			selection_devices 		: [],
			options_dev  			: {},
			total_dev   			: 0,
			loading_dev 			: false, 
			info_permission 		: {},
			list_permissions 		: [], 	
			list_permission_resources : [],
			permission_language_render_version : 0,
			permission_preset : {
				name: '',
				show_preview: false,
				loading: false,
				operations: [],
				preview: {
					create: 0,
					update: 0,
					skip: 0,
				},
			},
			permission_options 		: ['can_edit', 'can_view',  'can_add', 'can_delete'],
			search_permission  		: "",
			btn_options_permissions : [
				{
					key 		: "unlisted_permissions",
					color 		: "primary",
					action 		: 'add_unlisted_permissions',			
					text 		: vm.$ml.get("add_unlisted_permissions"),		
					icon 		: "mdi-notebook-plus",
					class 		: "mx-2",
				},
				{
					key 		: "add_permission",
					color 		: "primary",
					action 		: 'add_permission',					
					text 		: vm.$ml.get("add_permission"),		
					icon 		: "mdi-plus",

				},
				{
					key 		: "add_permission",
					color 		: "success",
					action 		: 'save_role_permissions',
					text 		: vm.$ml.get("save"),
					icon 		: "mdi-content-save",
					class 		: "mx-2",
				},
			],
			info_permissions_fields : [
				{
					key 	: "name",
					type 	: "text",
					text 	: vm.$ml.get("name"),
					class 	: "",
					icon 	: "mdi-rename-box",
					cols 	: "12",
				},
				{ //  can_add, can_view, can_edit , can_delete			
					key 	: "can_add",
					type 	: "switch",
					text 	: vm.$ml.get("can_add"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_view",
					type 	: "switch",
					text 	: vm.$ml.get("can_view"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_edit",
					type 	: "switch",
					text 	: vm.$ml.get("can_edit"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_delete",
					type 	: "switch",
					text 	: vm.$ml.get("can_delete"),
					class 	: "",
					cols 	: "6",
				}

			]

		}), // data

		created(){
			if (this.$route.name == 'list_face') {
				this.head.title1 = 'face';
			}
			let obj_new =  this.$Helper.set_property_obj(this.info_fields);
			if (obj_new) {
				this.info = obj_new;
			}
			this.get_permisions();

			// this.get_listing()
			// this.get_profiles();
				
		}, // created

		watch : {
			'$ml.current'(){
				this.permission_language_render_version += 1;
				this.$nextTick(() => this.$forceUpdate());
			},

			options : { 
				handler(){
					this.get_list();
				}, deep : true
			}, // options			
		
		}, // watch

		computed : {
			currentUser(){
				return this.$store.getters["auth/user"];
			},

			authPermissions(){
				return this.$store.state.auth.permissions;
			},

			isSuperAdmin(){
				return !!(this.currentUser && this.currentUser.user && this.currentUser.user.roleId == 1);
			},

			canEditRoles(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasRolesPermissionAction('can_edit');
			},

			canDeleteRoles(){
				if (this.isSuperAdmin) {
					return true;
				}
				return this.hasRolesPermissionAction('can_delete');
			},

			showRoleActions(){
				return this.canEditRoles || this.canDeleteRoles;
			},

			permission_matrix_render_key(){
				return 'permission-matrix-' + this.$ml.current + '-' + this.permission_language_render_version;
			},

			header_table(){
				this.$ml.current;
				const firstColumnValue = this.$route.name == 'list_face' ? 'entity' : 'name';
				const firstColumnText = this.$route.name == 'list_face' ? this.$ml.get('entity') : this.$ml.get('name');
				const headers = [
					{ text: firstColumnText, value: firstColumnValue, align: 'center' },
					{ text: this.$ml.get('date'), 'value': 'createdAt', align: 'center'}
				];

				if (this.showRoleActions) {
					headers.push({ text: this.$ml.get('actions'), value: 'actions', align: 'center' });
				}

				return headers;
			},

			header_table_dev(){
				this.$ml.current;
				return [
					{ text: this.$ml.get('permission_matrix_resource'), value: 'name' },
					{ text: this.$ml.get('can_view'), value: 'can_view' },
					{ text: this.$ml.get('can_add'), value: 'can_add' },
					{ text: this.$ml.get('can_edit'), value: 'can_edit' },
					{ text: this.$ml.get('can_delete'), value: 'can_delete' },
					{ text: this.$ml.get('actions'), value: 'actions', align: 'center'}
				]
			},

			
			render_list : function(){
				return this.list;
			}, // render_list

			/*devices : function(){
				let devs 		= this.$store.getters["Devices/list"];

				if (devs && devs.length) {
					this.total_dev 	= devs.length;
				}else {
					this.total_dev 	= 0;

				}
				return devs;
			},*/

			permissions : function(){
				this.$ml.current;
				const mappedPermissions = this.list_permissions.map(item => this.formatPermissionPresentation(item));
				let list = this.buildPermissionDisplayList(mappedPermissions);
				const settingsSuffixes = this.getSettingsPermissionOptionSuffixes();
				list = list.filter(item => {
					if (this.getPermissionGroupSuffix(item) != 'settings') {
						return true;
					}
					return settingsSuffixes.includes(this.getPermissionMlSuffix(item));
				});
				list = this.deduplicateVisiblePermissionRows(list);
				if (this.search_permission) {
					const search = this.search_permission.toLowerCase();
					list = list.filter(x => (
						x && (
							String(x.name || '').toLowerCase().includes(search) ||
							String(x.permission_label || '').toLowerCase().includes(search) ||
							String(x.permission_description || '').toLowerCase().includes(search) ||
							String(x.permission_group || '').toLowerCase().includes(search)
						)
					))
				}
				list = list.sort((a, b) => {
					const groupOrder = a.permission_group_order - b.permission_group_order;
					if (groupOrder !== 0) {
						return groupOrder;
					}

					const permissionOrder = a.permission_order - b.permission_order;
					if (permissionOrder !== 0) {
						return permissionOrder;
					}

					return String(a.permission_label || '').localeCompare(String(b.permission_label || ''));
				});
				this.total_dev = list.length;
				return list;
			},

			permission_table_height(){
				return Math.max(this.layout_height - 70, 680) + 'px';
			},

		}, // computed

		methods : {
			findPermissionRowIndex(permissionRow){
				const targetName = this.normalizePermissionName(permissionRow && permissionRow.name);
				const targetKey = this.normalizePermissionKey(permissionRow && permissionRow.name);
				const targetResourceId = permissionRow && permissionRow.resourceId != null ? Number(permissionRow.resourceId) : null;

				return this.list_permissions.findIndex(row => {
					if (!row) {
						return false;
					}

					const rowName = this.normalizePermissionName(row.name);
					const rowKey = this.normalizePermissionKey(row.name);
					const rowResourceId = row.resourceId != null ? Number(row.resourceId) : null;

					return (targetName && rowName == targetName)
						|| (targetKey && rowKey == targetKey)
						|| (targetResourceId != null && rowResourceId == targetResourceId);
				});
			},

			collectPermissionMatchKeys(permissionRow){
				const normalizedName = this.normalizePermissionName(permissionRow && permissionRow.name);
				const normalizedKey = this.normalizePermissionKey(permissionRow && permissionRow.name);
				const keys = [normalizedName, normalizedKey].filter(Boolean);
				return Array.from(new Set(keys));
			},

			canGrantPermission(permissionRow, action){
				if (this.isSuperAdmin) {
					return true;
				}

				const permissionGetter = this.$store.getters["auth/permission"];
				if (typeof permissionGetter != 'function' || !action) {
					return false;
				}

				const keys = this.collectPermissionMatchKeys(permissionRow);
				if (!keys.length) {
					return false;
				}

				return keys.some(key => permissionGetter(key, action, key));
			},

			isPermissionToggleDisabled(permissionRow, action){
				if (this.isSuperAdmin) {
					return false;
				}

				return !this.canGrantPermission(permissionRow, action);
			},

			getPermissionGroupRows(group){
				return (this.permissions || []).filter(item => (
					item && (item.permission_group_key == group || item.permission_group == group)
				));
			},

			canTogglePermissionGroup(group){
				return this.getPermissionGroupRows(group).some(row => (
					this.permission_options.some(action => this.canGrantPermission(row, action))
				));
			},

			isPermissionGroupFullyEnabled(group){
				const rows = this.getPermissionGroupRows(group);
				const grantablePairs = [];

				rows.forEach(row => {
					this.permission_options.forEach(action => {
						if (this.canGrantPermission(row, action)) {
							grantablePairs.push({ row, action });
						}
					});
				});

				return grantablePairs.length > 0 && grantablePairs.every(({ row, action }) => (
					this.toBooleanPermissionValue(row[action])
				));
			},

			setPermissionActionValue(permissionRow, action, value){
				let idx = this.findPermissionRowIndex(permissionRow);
				const basePermission = idx >= 0
					? this.list_permissions[idx]
					: {
						name: permissionRow.name,
						resourceId: permissionRow && permissionRow.resourceId != null ? Number(permissionRow.resourceId) : null,
						roleId: this.info && this.info.id ? this.info.id : null,
						can_view: this.toBooleanPermissionValue(permissionRow.can_view),
						can_add: this.toBooleanPermissionValue(permissionRow.can_add),
						can_edit: this.toBooleanPermissionValue(permissionRow.can_edit),
						can_delete: this.toBooleanPermissionValue(permissionRow.can_delete),
					};

				const permission = this.sanitizeDelegatedPermission({
					...basePermission,
					[action]: value,
				});

				if (idx >= 0) {
					this.list_permissions.splice(idx, 1, permission);
					return;
				}

				this.list_permissions.push(permission);
			},

			togglePermissionGroup(group){
				if (!this.canTogglePermissionGroup(group)) {
					this.$EventBus.$emit('notifications_modal',{
						type   : 'warning',
						message: this.$ml.get('permission_denied')
					});
					return;
				}

				const enableGroup = !this.isPermissionGroupFullyEnabled(group);

				this.getPermissionGroupRows(group).forEach(row => {
					this.permission_options.forEach(action => {
						if (this.canGrantPermission(row, action)) {
							this.setPermissionActionValue(row, action, enableGroup);
						}
					});
				});

				if (this.btn_action == "update" && this.info && this.info.id) {
					this.save_role_permissions();
				}
			},

			sanitizeDelegatedPermission(permission){
				const base = this.toPermissionMatrixItem(permission, this.info && this.info.id ? this.info.id : (permission && permission.roleId ? permission.roleId : null));
				if (this.isSuperAdmin) {
					return base;
				}

				const sanitized = { ...base };
				this.permission_options.forEach(action => {
					if (sanitized[action] && !this.canGrantPermission(sanitized, action)) {
						sanitized[action] = false;
					}
				});

				return sanitized;
			},

			hasRolesPermissionAction(action){
				const permissionGetter = this.$store.getters["auth/permission"];
				const permissions = this.authPermissions;
				const rolesPermissionKeys = [
					'/api/v1/roles',
					'api/v1/roles',
					'/api/v1/role',
					'api/v1/role',
					'api_v1_roles',
					'api_v1_role',
					'roles'
				];

				if (!permissions || typeof permissionGetter !== 'function') {
					return false;
				}

				return rolesPermissionKeys.some((permissionName) => {
					return permissionGetter(permissionName, action, permissionName);
				});
			},

			isHiddenPermissionMatrixRow(item){
				const suffix = this.getPermissionMlSuffix(item);
				return ['new_device', 'new_peripheral'].includes(suffix);
			},

			buildPermissionDisplayList(mappedPermissions){
				const settingsRows = this.buildSettingsSuboptionRows(mappedPermissions);
				const nonSettingsRows = mappedPermissions.filter(item => {
					return this.getPermissionGroupSuffix(item) !== 'settings' && !this.isHiddenPermissionMatrixRow(item);
				});

				return [
					...nonSettingsRows,
					...settingsRows,
				];
			},

			buildSettingsSuboptionRows(mappedPermissions){
				const settingsOptions = this.getSettingsPermissionOptions();
				if (!settingsOptions.length) {
					return [];
				}

				const bySuffix = mappedPermissions.reduce((acc, permission) => {
					const suffix = this.getPermissionMlSuffix(permission);
					if (suffix) {
						acc[suffix] = permission;
					}
					return acc;
				}, {});
				const byResourceId = mappedPermissions.reduce((acc, permission) => {
					if (permission && permission.resourceId != null) {
						acc[String(permission.resourceId)] = permission;
					}
					return acc;
				}, {});
				const resourcesBySuffix = (this.list_permission_resources || []).reduce((acc, resource) => {
					const resourceId = resource && resource.id != null ? Number(resource.id) : null;
					const keys = this.collectResourceMatchKeys(resource);
					keys.forEach(key => {
						if (!acc[key]) {
							acc[key] = { resource, resourceId };
						}
					});
					return acc;
				}, {});

				return settingsOptions.map((option, idx) => {
					const suffix = option.suffix;
					const aliasSuffixes = this.getSettingsSuboptionAliases(suffix);
					const matchBySuffix = aliasSuffixes.map(alias => bySuffix[alias]).find(Boolean) || null;
					const resourceMatch = aliasSuffixes.map(alias => resourcesBySuffix[alias]).find(Boolean) || null;
					const matchByResourceId = resourceMatch && resourceMatch.resourceId != null
						? byResourceId[String(resourceMatch.resourceId)]
						: null;
					const existing = matchBySuffix || matchByResourceId;

					if (existing) {
						return this.formatPermissionPresentation({
							...existing,
							name: suffix,
							resourceId: existing.resourceId != null
								? existing.resourceId
								: (resourceMatch ? resourceMatch.resourceId : null),
						});
					}

					return this.formatPermissionPresentation({
						name: suffix,
						roleId: this.info && this.info.id ? this.info.id : null,
						resourceId: resourceMatch ? resourceMatch.resourceId : null,
						can_view: false,
						can_add: false,
						can_edit: false,
						can_delete: false,
						permission_order: idx,
					});
				});
			},

			isSettingsSuboption(item){
				const suffix = this.getPermissionMlSuffix(item);
				return this.getSettingsPermissionOptionSuffixes().includes(suffix);
			},

			normalizePermissionKey(key){
				return String(key || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
			},

			formatPermissionPresentation(item){
				const groupSuffix = this.getPermissionGroupSuffix(item);
				const moduleMeta = this.getPermissionModuleMeta(groupSuffix);
				const menuMeta = this.getPermissionMenuMeta(item);
				return {
					...item,
					permission_item_key: (item.id || item.name || groupSuffix) + '-' + this.$ml.current + '-' + this.permission_language_render_version,
					permission_group_key: groupSuffix,
					permission_group: moduleMeta.label,
					permission_group_order: moduleMeta.order,
					permission_group_icon: moduleMeta.icon,
					permission_order: menuMeta && typeof menuMeta.childOrder == 'number' ? menuMeta.childOrder : -1,
					permission_label: this.getPermissionLabel(item),
					permission_description: this.getPermissionDescription(item),
					permission_icon: menuMeta && menuMeta.item && menuMeta.item.icon ? menuMeta.item.icon : 'mdi-lock-check',
				}
			},

			getPermissionMenuMeta(item){
				const suffix = this.getPermissionMlSuffix(item);
				const modules = default_parameters && default_parameters.modules ? default_parameters.modules : [];
				const isVisibleChild = child => child && child.enable !== false;

				if (this.isSettingsSuboption(item)) {
					const settingsModule = modules.find(module => (
						this.normalizePermissionKey(module && (module.modul || module.module || module.sub_module)) == 'settings'
					));
					const settingsOptions = this.getSettingsPermissionOptions();
					const optionIndex = settingsOptions.findIndex(option => option.suffix == suffix);
					const option = optionIndex >= 0 ? settingsOptions[optionIndex] : null;

					if (option) {
						return {
							item: option,
							parent: settingsModule || option,
							order: modules.indexOf(settingsModule),
							childOrder: optionIndex,
						};
					}
				}

				for (let idx = 0; idx < modules.length; idx++) {
					const module = modules[idx];
					if (!module) {
						continue;
					}

					if ([module.module, module.sub_module, module.modul].includes(suffix)) {
						return { item: module, parent: module, order: idx };
					}

					const children = [
						...(module.sub_modules || []),
						...(module.assosiateds || []),
					].filter(child => isVisibleChild(child) && this.normalizePermissionKey(module && (module.modul || module.module || module.sub_module)) != 'settings');

					for (let childIdx = 0; childIdx < children.length; childIdx++) {
						const child = children[childIdx];
						if (child && [child.module, child.sub_module, child.modul].includes(suffix)) {
							return { item: child, parent: module, order: idx, childOrder: childIdx };
						}
					}
				}

				return null;
			},

			getPermissionModuleMeta(groupSuffix){
				const modulesFromMenu = default_parameters && default_parameters.modules ? default_parameters.modules : [];
				const moduleIndex = modulesFromMenu.findIndex(module => (
					module && [module.module, module.modul, module.sub_module].includes(groupSuffix)
				));

				if (moduleIndex >= 0) {
					const module = modulesFromMenu[moduleIndex];
					const labelKey = module.title || module.module || module.modul;
					const translated = labelKey ? this.$ml.get(labelKey) : '';

					return {
						label: translated && translated != labelKey ? translated : this.getFallbackPermissionGroup(groupSuffix),
						icon: module.icon || 'mdi-folder-lock',
						order: (moduleIndex + 1) * 10,
					};
				}

				const modules = {
					dashboard: { label: this.$ml.get('dashboard'), icon: 'mdi-view-dashboard', order: 10 },
					device: { label: this.$ml.get('device'), icon: 'mdi-devices', order: 20 },
					nvr: { label: this.$ml.get('nvr'), icon: 'mdi-cctv', order: 30 },
					zones: { label: this.$ml.get('zones'), icon: 'mdi-map-marker', order: 40 },
					lists: { label: this.$ml.get('lists'), icon: 'mdi-file-document', order: 50 },
					profiles: { label: this.$ml.get('profiles'), icon: 'mdi-account-circle', order: 60 },
					lpr: { label: this.$ml.get('lpr'), icon: 'mdi-card-text', order: 70 },
					parking: { label: this.$ml.get('parking'), icon: 'mdi-parking', order: 80 },
					avc: { label: this.$ml.get('avc'), icon: 'mdi-airplane', order: 90 },
					face: { label: this.$ml.get('face'), icon: 'mdi-face-recognition', order: 100 },
					workspaces: { label: this.$ml.get('workspaces'), icon: 'mdi-monitor', order: 110 },
					contacts: { label: this.$ml.get('contacts'), icon: 'mdi-contacts', order: 120 },
					smart_event: { label: this.$ml.get('smart_event'), icon: 'mdi-alert-decagram', order: 130 },
					user: { label: this.$ml.get('user'), icon: 'mdi-account', order: 140 },
					settings: { label: this.$ml.get('settings'), icon: 'mdi-cog', order: 150 },
				};

				const module = modules[groupSuffix] || modules.settings;
				return {
					...module,
					label: module.label && module.label !== groupSuffix ? module.label : this.getFallbackPermissionGroup(groupSuffix),
				};
			},

			getFallbackPermissionGroup(groupSuffix){
				const key = `permission_group_${groupSuffix}`;
				const translated = this.$ml.get(key);

				if (translated && translated != key) {
					return translated;
				}

				return groupSuffix ? groupSuffix.replace(/_/g, ' ') : this.$ml.get('permission_matrix_resource');
			},

			getPermissionGroupIcon(group){
				const permission = this.permissions.find(item => item.permission_group == group || item.permission_group_key == group);
				return permission && permission.permission_group_icon ? permission.permission_group_icon : 'mdi-folder-lock';
			},

			getPermissionMlSuffix(item){
				let name = item && item.name ? item.name : '';
				return String(name).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
			},

			humanizePermissionSuffix(suffix){
				const normalized = this.normalizePermissionKey(suffix);
				if (!normalized) {
					return this.$ml.get('permission_matrix_resource');
				}

				return normalized
					.split('_')
					.filter(Boolean)
					.map(part => {
						if (/^(api|lpr|nvr|avc)$/i.test(part)) {
							return part.toUpperCase();
						}

						return part.charAt(0).toUpperCase() + part.slice(1);
					})
					.join(' ');
			},

			getPermissionGroupSuffix(item){
				const suffix = this.getPermissionMlSuffix(item);
				const menuMeta = this.getPermissionMenuMeta(item);

				if (this.isSettingsSuboption(item)) {
					return 'settings';
				}

				if (menuMeta && menuMeta.parent) {
					return menuMeta.parent.modul || menuMeta.parent.module || suffix || 'settings';
				}

				const groupByPermission = {
					new_device: 'device',
					new_peripheral: 'device',
					setting_device: 'device',
					setting_analytic: 'device',
					playback: 'nvr',
					settings_zones: 'zones',
					reports_lpr: 'lpr',
					list_lpr: 'lpr',
					reports_parking: 'parking',
					list_parking: 'parking',
					reports_avc: 'avc',
					trained: 'face',
					list_face: 'face',
					reports_face: 'face',
					search_by_video_face: 'face',
					reports_alarms: 'smart_event',
					api_v1_permission: 'user',
					api_v1_permissions: 'user',
					api_v1_users: 'user',
					api_v1_role: 'user',
					api_v1_roles: 'user',
					api_v1_resource: 'user',
					api_v1_resources: 'user',
					admin: 'settings',
					reports: 'settings',
				};

				if (groupByPermission[suffix]) {
					return groupByPermission[suffix];
				}

				const knownModule = this.getKnownPermissionGroups().includes(suffix);
				return knownModule ? suffix : 'settings';
			},

			getKnownPermissionGroups(){
				const modules = default_parameters && default_parameters.modules ? default_parameters.modules : [];
				return modules
					.map(module => this.normalizePermissionKey(module && (module.modul || module.module || module.sub_module)))
					.filter(Boolean);
			},

			getSettingsPermissionOptionSuffixes(){
				return this.getSettingsPermissionOptions().map(option => option.suffix);
			},

			getSettingsPermissionOptions(){
				const modules = default_parameters && default_parameters.modules ? default_parameters.modules : [];
				const settingsModule = modules.find(module => (
					this.normalizePermissionKey(module && (module.modul || module.module || module.sub_module)) == 'settings'
				));

				const options = [
					...((settingsModule && settingsModule.sub_modules) || []),
					...((settingsModule && settingsModule.assosiateds) || []),
				]
					.filter(option => option && option.enable !== false)
					.map(option => {
						const suffix = this.normalizePermissionKey(option && (option.sub_module || option.module || option.modul));
						return suffix ? { ...option, suffix } : null;
					})
					.filter(Boolean);

				const normalizedMap = {};
				options.forEach(option => {
					if (!normalizedMap[option.suffix]) {
						normalizedMap[option.suffix] = option;
					}
				});

				return Object.values(normalizedMap);
			},

			getSettingsSuboptionAliases(suffix){
				const normalized = this.normalizePermissionKey(suffix);
				const aliasMap = {
					time_zone: ['timezone'],
					timezone: ['time_zone'],
					workspaces: ['workstations', 'workspace'],
					workstations: ['workspaces', 'workspace'],
				};
				const aliases = aliasMap[normalized] || [];
				return [normalized, ...aliases].map(item => this.normalizePermissionKey(item)).filter(Boolean);
			},

			getPermissionLabel(item){
				const suffix = this.getPermissionMlSuffix(item);
				const key = suffix ? `permission_label_${suffix}` : '';
				const menuMeta = this.getPermissionMenuMeta(item);

				if (key) {
					const translated = this.$ml.get(key);
					if (translated && translated != key) {
						return translated;
					}
				}

				if (menuMeta && menuMeta.item) {
					const labelKey = menuMeta.item.title || menuMeta.item.module || menuMeta.item.sub_module || menuMeta.item.name;
					const translated = labelKey ? this.$ml.get(labelKey) : '';

					if (translated && translated != labelKey) {
						return translated;
					}

					if (labelKey) {
						return String(labelKey).replace(/_/g, ' ');
					}
				}

				return this.humanizePermissionSuffix(suffix);
			},

			getPermissionDescription(item){
				const suffix = this.getPermissionMlSuffix(item);
				const key = suffix ? `permission_desc_${suffix}` : '';

				if (key) {
					const translated = this.$ml.get(key);
					if (translated && translated != key) {
						return translated;
					}
				}

				return this.$ml.get('permission_desc_default');
			},

			actions(act, item, opt) {
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
					if (this.show.add) {
						if (this.btn_action == 'save') {
							this.show.unlisted_permissions = false;
						}else{
							this.show.unlisted_permissions = true;

						}
						this.list_permissions = this.$store.getters["auth/list_default_permissions"];
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
					this.show.unlisted_permissions = true;

					// this.render_input('type_integrate');

				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {
					this.info 		= { ...item };
					// this.info_item 	= this.list.indexOf(item);
					// this.render_input('type_integrate');

					this.show.add 					= true;
					this.sub_title 					= this.$ml.get('update');
					this.btn_action 				= 'update';
					this.info_item  				= { ...item };
					this.show.unlisted_permissions 	= true;


					/*if (item && item.devices && item.devices.length > 0) {
						this.selection_devices = item.devices;
					}*/
					this.find_permissions(item);

				}
				if ( act == 'confirm_delete') {
					this.info_item = { ...item };
					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});

				}else 
				if (act == "confirm_delete_dev"){
					this.info_item = { item : {...item}, action : "delete_permission" };
					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}
				if ( act == 'change_value_permission') {
					if (!this.canGrantPermission(item, opt)) {
						this.$EventBus.$emit('notifications_modal',{
							type   : 'warning',
							message: this.$ml.get('permission_denied')
						});
						return;
					}
					let idx = this.findPermissionRowIndex(item);
					if (idx >= 0) {
						const permission = this.sanitizeDelegatedPermission({
							...this.list_permissions[idx],
							[opt]: !this.toBooleanPermissionValue(this.list_permissions[idx][opt]),
						});
						this.list_permissions.splice(idx, 1, permission);
						if (this.btn_action == "update") {
							if (permission && permission.id) {
								this.update_permission(permission);
							}else if (this.info && this.info.id) {
								this.create_permission_for_role(permission);
							}
						}
					}else{
						const permission = {
							name: item.name,
							resourceId: item && item.resourceId != null ? Number(item.resourceId) : null,
							roleId: this.info && this.info.id ? this.info.id : null,
							can_view: this.toBooleanPermissionValue(item.can_view),
							can_add: this.toBooleanPermissionValue(item.can_add),
							can_edit: this.toBooleanPermissionValue(item.can_edit),
							can_delete: this.toBooleanPermissionValue(item.can_delete),
						};
						permission[opt] = !permission[opt];
						const sanitizedPermission = this.sanitizeDelegatedPermission(permission);

						if (this.btn_action == "update" && this.info && this.info.id) {
							this.create_permission_for_role(sanitizedPermission);
						}else{
							this.list_permissions.push(sanitizedPermission);
						}
					}

				}else 
				if (act  == "add_unlisted_permissions"){
					this.save_unlited_permissions();
				}else
				if (act == "add_permission") {
					this.show.show_add_permission = !this.show.show_add_permission;
				}else
				if (act == "save_permission") {					
					this.save_permission();
				}else
				if (act == "save_role_permissions") {
					this.save_role_permissions();
				}
			}, // actions

			normalizePermissionName(name){
				return String(name || '').trim().toLowerCase();
			},

			canonicalPermissionName(name){
				const normalizedName = this.normalizePermissionName(name);
				const normalizedKey = this.normalizePermissionKey(normalizedName);

				if (['device', 'devices'].includes(normalizedName) || ['device', 'devices'].includes(normalizedKey)) {
					return 'device';
				}

				return normalizedName;
			},

			toBooleanPermissionValue(value){
				return value === true || value === 1 || value === '1' || value === 'true';
			},

			toPermissionMatrixItem(permission, roleId){
				const payload = permission && permission.permission ? permission.permission : permission;
				const normalizedName = this.canonicalPermissionName(payload && payload.name ? payload.name : '');
				const resourceId = payload && payload.resourceId != null ? Number(payload.resourceId) : null;
				return {
					...payload,
					name: normalizedName,
					roleId: roleId,
					resourceId,
					can_add: this.toBooleanPermissionValue(payload && payload.can_add),
					can_view: this.toBooleanPermissionValue(payload && payload.can_view),
					can_edit: this.toBooleanPermissionValue(payload && payload.can_edit),
					can_delete: this.toBooleanPermissionValue(payload && payload.can_delete),
				};
			},

			collectPermissionDedupKeys(permission){
				const normalizedName = this.canonicalPermissionName(permission && permission.name);
				const normalizedKey = this.normalizePermissionKey(normalizedName);
				const keys = [];
				if (normalizedName) {
					keys.push(`name:${normalizedName}`);
				}
				if (normalizedKey) {
					keys.push(`key:${normalizedKey}`);
				}
				if (!normalizedName && !normalizedKey && permission && permission.resourceId != null) {
					keys.push(`resource:${String(permission.resourceId)}`);
				}
				return keys;
			},

			mergePermissionRows(existing, incoming){
				const preferred = existing && existing.id ? existing : (incoming && incoming.id ? incoming : existing);
				const secondary = preferred === existing ? incoming : existing;
				return {
					...(secondary || {}),
					...(preferred || {}),
					name: this.canonicalPermissionName((preferred && preferred.name) || (secondary && secondary.name) || ''),
					resourceId: preferred && preferred.resourceId != null
						? Number(preferred.resourceId)
						: (secondary && secondary.resourceId != null ? Number(secondary.resourceId) : null),
					can_add: this.toBooleanPermissionValue(preferred && preferred.can_add) || this.toBooleanPermissionValue(secondary && secondary.can_add),
					can_view: this.toBooleanPermissionValue(preferred && preferred.can_view) || this.toBooleanPermissionValue(secondary && secondary.can_view),
					can_edit: this.toBooleanPermissionValue(preferred && preferred.can_edit) || this.toBooleanPermissionValue(secondary && secondary.can_edit),
					can_delete: this.toBooleanPermissionValue(preferred && preferred.can_delete) || this.toBooleanPermissionValue(secondary && secondary.can_delete),
				};
			},

			deduplicatePermissionRows(rows){
				const uniqueRows = [];
				const indexByKey = {};

				(rows || []).forEach(raw => {
					const row = this.toPermissionMatrixItem(raw, raw && raw.roleId ? raw.roleId : (this.info && this.info.id ? this.info.id : null));
					const keys = this.collectPermissionDedupKeys(row);
					const existingIndex = keys.map(key => indexByKey[key]).find(idx => typeof idx == 'number');

					if (typeof existingIndex == 'number') {
						uniqueRows[existingIndex] = this.mergePermissionRows(uniqueRows[existingIndex], row);
						this.collectPermissionDedupKeys(uniqueRows[existingIndex]).forEach(key => {
							indexByKey[key] = existingIndex;
						});
						return;
					}

					const nextIndex = uniqueRows.length;
					uniqueRows.push({ ...row });
					keys.forEach(key => {
						indexByKey[key] = nextIndex;
					});
				});

				return uniqueRows;
			},

			normalizeDisplayPermissionValue(value){
				return String(value || '').trim().toLowerCase();
			},

			getPermissionDisplayDedupKey(item){
				return [
					this.normalizeDisplayPermissionValue(item && item.permission_group_key),
					this.normalizeDisplayPermissionValue(item && item.permission_label),
					this.normalizeDisplayPermissionValue(item && item.permission_description),
				].join('||');
			},

			deduplicateVisiblePermissionRows(rows){
				const uniqueRows = [];
				const indexByDisplayKey = {};

				(rows || []).forEach(row => {
					const displayKey = this.getPermissionDisplayDedupKey(row);
					const existingIndex = indexByDisplayKey[displayKey];

					if (typeof existingIndex == 'number') {
						uniqueRows[existingIndex] = this.formatPermissionPresentation(this.mergePermissionRows(uniqueRows[existingIndex], row));
						return;
					}

					const nextIndex = uniqueRows.length;
					uniqueRows.push({ ...row });
					indexByDisplayKey[displayKey] = nextIndex;
				});

				return uniqueRows;
			},

			collectResourceMatchKeys(resource){
				const rawKeys = [
					resource && resource.name,
					resource && resource.module,
					resource && resource.sub_module,
					resource && resource.modul,
				];

				const set = new Set();
				rawKeys.forEach(value => {
					const normalized = this.normalizePermissionName(value);
					if (normalized) {
						set.add(normalized);
						set.add(this.normalizePermissionKey(normalized));
					}
				});

				return Array.from(set);
			},

			getPermissionNameFromResource(item){
				if (!item) {
					return '';
				}
				return this.canonicalPermissionName(item.module || item.sub_module || item.modul || item.name);
			},

			buildExpectedPermissionRows(roleId, resourcesFromApi){
				const resourcesByKey = (resourcesFromApi || []).reduce((acc, resource) => {
					this.collectResourceMatchKeys(resource).forEach(key => {
						if (!acc[key]) {
							acc[key] = resource;
						}
					});
					return acc;
				}, {});

				const expectedByName = {};
				const modules = default_parameters && default_parameters.modules ? default_parameters.modules : [];
				const addExpected = (resourceLike) => {
					if (!resourceLike || resourceLike.enable === false || !resourceLike.type_component) {
						return;
					}

					const name = this.getPermissionNameFromResource(resourceLike);
					if (!name || expectedByName[name]) {
						return;
					}

					const resourceMatch = resourcesByKey[name] || null;
					expectedByName[name] = {
						name,
						roleId,
						resourceId: resourceMatch && resourceMatch.id != null ? Number(resourceMatch.id) : null,
						can_add: false,
						can_view: false,
						can_edit: false,
						can_delete: false,
					};
				};

				modules.forEach(module => {
					addExpected(module);
					(module.assosiateds || []).forEach(addExpected);
					(module.sub_modules || []).forEach(addExpected);
				});

				return Object.values(expectedByName);
			},

			list_resources(){
				const api = this.$URL + '/api/v1/resource';
				return this.$axios.get(api).then(res => {
					if (res && res.data && res.data.rows && res.data.rows.length > 0) {
						return res.data.rows;
					}
					return [];
				}).catch(() => []);
			},

			buildRolePermissionMatrix(roleId, permissionsFromApi, resourcesFromApi){
				const normalizedRows = (permissionsFromApi || []).map(item => this.toPermissionMatrixItem(item, roleId));
				const expectedRows = this.buildExpectedPermissionRows(roleId, resourcesFromApi);
				const mergedRows = [
					...normalizedRows,
					...expectedRows.filter(expected => {
						const expectedName = this.normalizePermissionName(expected && expected.name);
						return !normalizedRows.some(existing => this.normalizePermissionName(existing && existing.name) == expectedName);
					})
				];
				const byName = mergedRows.reduce((acc, item) => {
					if (item && item.name) {
						acc[item.name] = item;
						acc[this.normalizePermissionKey(item.name)] = item;
					}
					return acc;
				}, {});
				const byResourceId = mergedRows.reduce((acc, item) => {
					if (item && item.resourceId != null) {
						acc[String(item.resourceId)] = item;
					}
					return acc;
				}, {});

				const matrix = [];
				(resourcesFromApi || []).forEach(resource => {
					if (!resource || !resource.name) {
						return;
					}
					const resourceId = resource.id != null ? Number(resource.id) : null;
					const keys = this.collectResourceMatchKeys(resource);
					let existing = resourceId != null ? byResourceId[String(resourceId)] : null;

					if (!existing) {
						existing = keys.map(key => byName[key]).find(Boolean) || null;
					}

					const preferredName = keys[0] || this.normalizePermissionName(resource && resource.name);
					if (existing) {
						matrix.push({
							...existing,
							name: existing.name || preferredName,
							resourceId: existing.resourceId != null ? existing.resourceId : resourceId,
						});
						if (existing.name) {
							delete byName[existing.name];
							delete byName[this.normalizePermissionKey(existing.name)];
						}
						if (existing.resourceId != null) {
							delete byResourceId[String(existing.resourceId)];
						}
					} else {
						matrix.push({
							name: preferredName,
							roleId,
							resourceId,
							can_add: false,
							can_view: false,
							can_edit: false,
							can_delete: false,
						});
					}
				});

				const remainingByKey = {};
				Object.values(byName).forEach(item => {
					if (!item) {
						return;
					}
					const uniqueKey = [item.id || '', item.resourceId || '', item.name || ''].join('|');
					if (!remainingByKey[uniqueKey]) {
						remainingByKey[uniqueKey] = item;
					}
				});
				Object.values(remainingByKey).forEach(item => {
					matrix.push({ ...item });
				});

				return this.deduplicatePermissionRows(matrix);
			},

			getRolePermissionsFromApi(role){
				const api = this.$URL + '/api/v1/permissions/find';
				return this.$axios.post(api, role).then(res => (
					res && res.data && res.data.rows ? res.data.rows : []
				)).catch(() => []);
			},

			getResourceNameById(resourceId, resources){
				const resource = (resources || []).find(item => (
					item && item.id != null && Number(item.id) == Number(resourceId)
				));

				return resource ? (resource.name || resource.module || resource.sub_module || resource.modul || '') : '';
			},

			buildResourceIndex(resources){
				return (resources || []).reduce((acc, resource) => {
					this.collectResourceMatchKeys(resource).forEach(key => {
						if (!acc[key]) {
							acc[key] = resource;
						}
					});
					return acc;
				}, {});
			},

			buildPermissionPresetPayload(role, permission, resources){
				const normalized = this.toPermissionMatrixItem(permission, role && role.id ? role.id : null);
				return {
					name: normalized.name,
					resourceName: this.getResourceNameById(normalized.resourceId, resources),
					can_view: normalized.can_view,
					can_add: normalized.can_add,
					can_edit: normalized.can_edit,
					can_delete: normalized.can_delete,
				};
			},

			exportPermissionPreset(){
				const roles = (this.list || []).filter(role => role && role.name && role.name != 'SuperAdmin');
				if (!roles.length) {
					this.$EventBus.$emit('notifications_modal',{
						type   : 'warning',
						message: this.$ml.get('data_no_found')
					});
					return;
				}

				this.permission_preset.loading = true;
				this.list_resources().then(resources => {
					let chain = Promise.resolve([]);
					roles.forEach(role => {
						chain = chain.then(result => this.getRolePermissionsFromApi(role).then(permissionRows => {
							result.push({
								name: role.name,
								permissions: this.deduplicatePermissionRows(permissionRows).map(permission => (
									this.buildPermissionPresetPayload(role, permission, resources)
								)),
							});
							return result;
						}));
					});

					return chain;
				}).then(presetRoles => {
					const preset = {
						version: 1,
						name: 'guardian-permission-preset',
						exportedAt: new Date().toISOString(),
						roles: presetRoles,
					};
					const blob = new Blob([JSON.stringify(preset, null, 2)], { type: 'application/json' });
					const url = URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = preset.name + '-' + new Date().toISOString().slice(0, 10) + '.json';
					link.click();
					URL.revokeObjectURL(url);
					this.permission_preset.loading = false;
				}).catch(err => {
					this.permission_preset.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type   : 'error',
						message: err,
					});
				});
			},

			openPermissionPresetImport(){
				if (this.$refs.permissionPresetInput) {
					this.$refs.permissionPresetInput.value = null;
					this.$refs.permissionPresetInput.click();
				}
			},

			handlePermissionPresetFile(event){
				const file = event && event.target && event.target.files ? event.target.files[0] : null;
				if (!file) {
					return;
				}

				const reader = new FileReader();
				reader.onload = () => {
					try {
						const preset = JSON.parse(reader.result);
						this.preparePermissionPresetPreview(preset);
					} catch (err) {
						this.$EventBus.$emit('notifications_modal',{
							type   : 'error',
							message: err,
						});
					}
				};
				reader.readAsText(file);
			},

			findPresetRole(roleName){
				const normalizedRoleName = this.normalizePermissionName(roleName);
				return (this.list || []).find(role => (
					role && this.normalizePermissionName(role.name) == normalizedRoleName
				));
			},

			resolvePresetResourceId(permission, resourceIndex){
				const keys = [
					permission && permission.resourceName,
					permission && permission.name,
				].map(value => this.normalizePermissionKey(value)).filter(Boolean);

				const resource = keys.map(key => resourceIndex[key]).find(Boolean);
				return resource && resource.id != null ? Number(resource.id) : null;
			},

			findExistingPresetPermission(existingPermissions, incomingPermission){
				const incomingName = this.normalizePermissionName(incomingPermission && incomingPermission.name);
				const incomingKey = this.normalizePermissionKey(incomingPermission && incomingPermission.name);
				const incomingResourceId = incomingPermission && incomingPermission.resourceId != null ? Number(incomingPermission.resourceId) : null;

				return (existingPermissions || []).find(permission => {
					const row = this.toPermissionMatrixItem(permission, incomingPermission.roleId);
					const rowName = this.normalizePermissionName(row.name);
					const rowKey = this.normalizePermissionKey(row.name);
					const rowResourceId = row.resourceId != null ? Number(row.resourceId) : null;

					return (incomingName && rowName == incomingName)
						|| (incomingKey && rowKey == incomingKey)
						|| (incomingResourceId != null && rowResourceId == incomingResourceId);
				});
			},

			sanitizePermissionPresetPayload(payload){
				const sanitized = {
					...payload,
					can_view: this.toBooleanPermissionValue(payload && payload.can_view),
					can_add: this.toBooleanPermissionValue(payload && payload.can_add),
					can_edit: this.toBooleanPermissionValue(payload && payload.can_edit),
					can_delete: this.toBooleanPermissionValue(payload && payload.can_delete),
				};

				if (this.isSuperAdmin) {
					return sanitized;
				}

				this.permission_options.forEach(action => {
					if (sanitized[action] && !this.canGrantPermission(sanitized, action)) {
						sanitized[action] = false;
					}
				});

				return sanitized;
			},

			isSamePermissionPayload(existing, incoming){
				const existingRow = this.toPermissionMatrixItem(existing, incoming.roleId);
				return this.permission_options.every(action => (
					this.toBooleanPermissionValue(existingRow[action]) == this.toBooleanPermissionValue(incoming[action])
				));
			},

			preparePermissionPresetPreview(preset){
				if (!preset || !Array.isArray(preset.roles)) {
					this.$EventBus.$emit('notifications_modal',{
						type   : 'error',
						message: 'Invalid permission preset'
					});
					return;
				}

				this.permission_preset.loading = true;
				this.permission_preset.name = preset.name || 'permission-preset';
				this.list_resources().then(resources => {
					const resourceIndex = this.buildResourceIndex(resources);
					const operations = [];
					let chain = Promise.resolve();

					preset.roles.forEach(presetRole => {
						chain = chain.then(() => {
							const localRole = this.findPresetRole(presetRole && presetRole.name);
							if (!localRole || localRole.name == 'SuperAdmin') {
								operations.push({
									roleName: presetRole && presetRole.name ? presetRole.name : '',
									name: '-',
									action: 'skip',
									can_view: false,
									can_add: false,
									can_edit: false,
									can_delete: false,
								});
								return Promise.resolve();
							}

							return this.getRolePermissionsFromApi(localRole).then(existingPermissions => {
								(presetRole.permissions || []).forEach(rawPermission => {
									const payload = this.sanitizePermissionPresetPayload({
										name: this.canonicalPermissionName(rawPermission && rawPermission.name),
										roleId: localRole.id,
										resourceId: this.resolvePresetResourceId(rawPermission, resourceIndex),
										can_view: rawPermission && rawPermission.can_view,
										can_add: rawPermission && rawPermission.can_add,
										can_edit: rawPermission && rawPermission.can_edit,
										can_delete: rawPermission && rawPermission.can_delete,
									});
									const existing = this.findExistingPresetPermission(existingPermissions, payload);
									const operation = {
										...payload,
										id: existing && existing.id ? existing.id : null,
										roleName: localRole.name,
										action: existing ? (this.isSamePermissionPayload(existing, payload) ? 'skip' : 'update') : 'create',
									};
									operations.push(operation);
								});
							});
						});
					});

					return chain.then(() => operations);
				}).then(operations => {
					this.permission_preset.operations = operations;
					this.permission_preset.preview = operations.reduce((acc, operation) => {
						if (operation.action == 'create') {
							acc.create += 1;
						}else if (operation.action == 'update') {
							acc.update += 1;
						}else{
							acc.skip += 1;
						}
						return acc;
					}, { create: 0, update: 0, skip: 0 });
					this.permission_preset.loading = false;
					this.permission_preset.show_preview = true;
				}).catch(err => {
					this.permission_preset.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type   : 'error',
						message: err,
					});
				});
			},

			applyPermissionPreset(){
				const operations = (this.permission_preset.operations || []).filter(operation => (
					operation.action == 'create' || operation.action == 'update'
				));

				if (!operations.length) {
					return;
				}

				this.permission_preset.loading = true;
				let chain = Promise.resolve();
				operations.forEach(operation => {
					chain = chain.then(() => {
						const payload = {
							name: operation.name,
							roleId: operation.roleId,
							resourceId: operation.resourceId || null,
							can_view: operation.can_view,
							can_add: operation.can_add,
							can_edit: operation.can_edit,
							can_delete: operation.can_delete,
						};

						if (operation.action == 'update' && operation.id) {
							return this.$axios.put(this.$URL + '/api/v1/permission/' + operation.id + '/', payload);
						}

						return this.$axios.post(this.$URL + '/api/v1/permission', payload);
					});
				});

				chain.then(() => {
					this.permission_preset.loading = false;
					this.permission_preset.show_preview = false;
					this.$EventBus.$emit('notifications_modal',{
						type   : 'saved',
						message: this.$ml.get('permissions'),
					});
					if (this.info && this.info.id) {
						this.find_permissions(this.info);
					}
				}).catch(err => {
					this.permission_preset.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type   : 'error',
						message: err,
					});
				});
			},

			create_permission_for_role(permission){
				const api = this.$URL + "/api/v1/permission";
				const sanitizedPermission = this.sanitizeDelegatedPermission(permission);
				const permissionName = String(sanitizedPermission && sanitizedPermission.name ? sanitizedPermission.name : '').toLowerCase();
				const info_up = {
					...sanitizedPermission,
					name: permissionName,
					roleId: this.info.id,
				};

				this.loading_dev = true;
				this.$axios.post(api, info_up).then(res => {
					this.loading_dev = false;
					if (res && res.data) {
						const idx = this.list_permissions.findIndex(x => (
							x && String(x.name || '').toLowerCase() == permissionName
						));
						if (idx >= 0) {
							this.list_permissions.splice(idx, 1, { ...res.data });
						}else{
							this.list_permissions.push({ ...res.data });
						}
						this.$store.commit("auth/create_permission", res.data);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "saved",
							message : this.$ml.get("permissions"),
						});
					}
				}).catch(err => {
					this.loading_dev = false;
					console.warn("Error create permission ", err);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err,
					});
				})
			},

			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list

			get_list(){
				const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/role/?page=' + page;
				this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						items.forEach((list_item) =>{
							if (list_item) {
								let temp = this.format_info(list_item);
								if (temp){
									list_item = temp; 
								}
							}
						})
					}
					this.total 	 = res.data.count;
					this.list  	 = [ ...items];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get_list');
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  err
					});
				})

			}, // get list


			
			get_permisions(){
				
				// const { itemsPerPage, page } = this.options;
				// let pg 		= 1;
				// let vm 		= this;
				// const api 	= this.$URL + '/api/v1/permission/?page=' + pg;
				// this.loading = true;
				// let info_up = this.$store.getters(["auth/list_permissions"])
				this.list_permissions 	= this.$store.getters["auth/list_default_permissions"];
				this.total_dev 			= this.list_permissions && this.list_permissions.length > 0 ? this.list_permissions.length : 0;
				/*this.loading_dev = true;
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	  		= res.data.rows;
					// this.total = res.data.count;
					this.loading_dev 	= false;

					this.total_dev = res.data.count;
					let temp_list = [];

					if (items && items.length > 0) {
						items.forEach((item_list) => {
							if (item_list) {
								temp_list.push(item_list);
							}
						})
					}
					console.log(" LISTS : ", temp_list, items)
					if (temp_list && temp_list.length > 0) {

						// this.list_permissions  	= [ ...temp_list ];
						// this.required_info 		= true;
					}else{

						this.$EventBus.$emit('notifications_modal', {
							type 	: 'warning',
							message : ' Required have list permissions'
						})
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					this.loading_dev 	= false;
					console.log(er, 'Error get_list');
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'Failed Get de permissions : ' + err
					})
					this.list_permissions = this.$store.getters["auth/list_permissions"];
					console.log("permissions  --------------------------...", this.list_permissions)
				})*/
			}, // get permissions

			find_permissions(item){
				const api 	= this.$URL + '/api/v1/permissions/find'; // ?page=' + pg
				this.loading_dev 	= true;
				const roleId = item && item.id ? item.id : null;
				this.list_permissions = [];
				this.total_dev = 0;
				if (!roleId) {
					this.loading_dev = false;
					return;
				}

				Promise.all([
					this.$axios.post(api, item).then(res => (res && res.data && res.data.rows ? res.data.rows : [])).catch(() => []),
					this.list_resources(),
				]).then(([permissionRows, resourcesRows]) => {
					this.list_permission_resources = resourcesRows;
					this.list_permissions = this.buildRolePermissionMatrix(roleId, permissionRows, resourcesRows);
					this.total_dev = this.list_permissions.length;
					this.loading_dev = false;
				}).catch(er => {
					console.log("Error find permission role ", er)
					this.list_permission_resources = [];
					this.loading_dev 	= false;
				})
			}, // find permissions

			save_role_permissions(){
				if (!this.info || !this.info.id) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("req_id_to_update"),
					});
					return;
				}

				const roleId = this.info.id;
				const deduplicatedPermissions = this.deduplicatePermissionRows(this.list_permissions || []);
				const permissionsToSave = deduplicatedPermissions.map(item => this.sanitizeDelegatedPermission(this.toPermissionMatrixItem(item, roleId)));
				this.list_permissions = permissionsToSave.map(item => ({ ...item }));
				this.loading_dev = true;

				let chain = Promise.resolve();
				permissionsToSave.forEach(permission => {
					chain = chain.then(() => {
						const payload = {
							name: permission.name,
							roleId: roleId,
							resourceId: permission.resourceId || null,
							can_add: permission.can_add,
							can_view: permission.can_view,
							can_edit: permission.can_edit,
							can_delete: permission.can_delete,
						};

						if (permission.id) {
							const apiUpdate = this.$URL + "/api/v1/permission/" + permission.id + "/";
							return this.$axios.put(apiUpdate, payload).then(() => payload);
						}

						const apiCreate = this.$URL + "/api/v1/permission";
						return this.$axios.post(apiCreate, payload).then(res => {
							if (res && res.data) {
								permission.id = res.data.id;
								permission.createdAt = res.data.createdAt;
								permission.updatedAt = res.data.updatedAt;
							}
							return payload;
						});
					});
				});

				chain.then(() => {
					this.loading_dev = false;
					this.$EventBus.$emit("notifications_modal",{
						type 	: "saved",
						message : this.$ml.get("permissions"),
					});
					this.find_permissions(this.info);
				}).catch(err => {
					this.loading_dev = false;
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err,
					});
				});
			},

			save(up){
				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/role';
				let check  	= false;
				let msg 	= ''; 
				// info_up["devices"] = this.selection_devices;
				const deduplicatedPermissions = this.deduplicatePermissionRows(this.list_permissions || []);
				info_up["permissions"] = deduplicatedPermissions.map(item => this.sanitizeDelegatedPermission(item));
				this.list_permissions = info_up["permissions"].map(item => ({ ...item }));
				this.loading = true;

				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check  = true;
						msg    = '';
					}
				}else{
					check = true;
				}

				/*if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list')
				}*/
				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						console.log('res ', opt, 'roles', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save
							this.total ++;
							let info_res = this.format_info(res.data);
							this.list.push(info_res);
						}else{
							let idx = this.list.indexOf(this.info_item);
							// console.log("update list : ", idx)
							// this.info_item = info_up;
							if (idx >= 0) {
								this.list.splice(idx, 1, info_up);
							}
						}
			    		// this.info_fields[2].enable 	= false;
			    		this.selection_devices 		= [];

						if (this.show.add) {
							this.actions('show');
						}
					}).catch(er => {
						this.loading = false;						
						console.log("Error list setting ", opt, er);
						let  err 	 = up ? 'update ' : 'save ';
						err 	 	+= er && er.message ? er.message : er;

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			/*save_pemissions(){
				const api 	= this.$URL + '/api/v1/permission';
				let info_up = this.info_permission;
				this.loading_permission = true;
				this.$axios.post(api, info_up).then(res => {
					console.log("permissions res : ", res)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "saved",
						message : this.$ml.get("permissions")
					})
					this.loading_permission = false;

				}).catch(err => {
					console.log("err permission save ", err)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err
					});
					this.loading_permission = false;


				})
			}, // save permissions

			update_pemissions(item){
				const api 	= this.$URL + '/api/v1/permission';
				let info_up = item;//this.info_permission;
				this.loading_permission = true;
				this.$axios.put(api, info_up).then(res => {
					console.log("permissions res update : ", res)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "updated",
						message : this.$ml.get("permissions")
					})
					this.loading_permission = false;

				}).catch(err => {
					console.log("err permission update ", err)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err
					});
					this.loading_permission = false;
					

				})
			}, // update permissions*/

			del(item){
				if (item) {
					let idx = this.list.indexOf(item);
					if (item.id) {
						this.loading = true;
						const api 	 = this.$URL + '/api/v1/cloud/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
								type : 'deleted', 							
							});
							this.list.splice(idx, 1);
							if (this.list && this.list.length === 0) {
								this.total = 0;
							}else{
								this.total = this.list && this.list.length == 1 ? 1 : this.list.length - 1;
							}
							this.loading   = false;							
							if (this.show.add) {
								this.actions('show');
							}
						}).catch( er => {
							console.log( "Error deleting ", er);
							this.loading = false;
							let  err 	 = up ? 'update ' : 'save ';
							err 		+= er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  'Deleting item ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  'Item to delete have id'
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  'Item to delete null'
					});
				}
			}, // del item

			format_info(item){
				if (item){
					if (item.listId) {
						let temp_lists = this.list_lists[this.list_lists.findIndex( x => x.id == item.listId)] ;						
						item.list = temp_lists ? temp_lists.name : false;
						
					}		
					if (item.createdAt) {
						item.date  = this.$momentz(item.createdAt).format('ll, LTS');
					}
					return item;			
				}
				return null
			}, // format info

			render_input(key){
				if (key == 'type_integrate' && this.info[key]){
					console.log("key : ", key,this.info[key])
					if(this.info[key] == 'cloud'){
			    		this.info_fields[1].enable 	= true;
		    			this.info_fields[2].enable  = true;
		    			this.info_fields[4].enable 	= false;
			    		this.info_fields[5].enable 	= false;
			    		this.info_fields[6].enable 	= false;

			    		delete this.info.name;
						delete this.info.port_socket;
			    	}
			    	else{
			    		this.info_fields[2].enable 	= false;
		    			delete this.info.name;
						delete this.info.port_socket;

			    		if (this.info.manager_id) {
			    			delete this.info.manager_id;
			    		}
			    		if (["module"].includes(this.info[key])) {
			    			this.info_fields[1].enable 	= true;
			    		}else{
			    			this.info_fields[1].enable 	= false;

			    		}
			    		if (this.info[key] == "guardian_cloud") {
			    			this.info_fields[4].enable 	= true;
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= false;

			    		}else 
			    		if (this.info[key] == "external_client"){
			    			this.info_fields[4].enable 	= false;			    			
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= true;

			    		}else{
			    			this.info_fields[4].enable 	= false;
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;
			    			
			    		}
			    		
			    	}
				}else{
					// this.info_fields[2].enable = false;
				}
			}, // render input

			save_permission(){
				let info_up = this.sanitizeDelegatedPermission({ ...this.info_permission });
				if (this.info && this.info.id) { // bd
					const api 	= this.$URL + "/api/v1/permission"
					this.loading_dev 	= true;
					info_up.roleId 		= this.info.id;
					this.$axios.post(api, info_up).then(res => {
						this.loading_dev = false;
						if (res && res.data) {
							this.list_permissions.push({ ...res.data });
							this.info_permission = {};
							this.$store.commit("auth/create_permission", res.data);
							this.$EventBus.$emit("notifications_modal",{
								type 	: "saved",
								message : this.$ml.get("permissions"),
							});			
							this.actions("add_permission");				
						}
					}).catch(er => {
						this.loading_dev = false;
						console.warn("Error create permission  ", er);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : er,
						});
					})
				}else{ // list permissions
					this.list_permissions.push({...info_up});
				}
			}, // save permission

			update_permission(item){
				if (item && item.id) {
					const sanitizedItem = this.sanitizeDelegatedPermission(item);
					const api = this.$URL + "/api/v1/permission/" + item.id;
					this.loading_dev = true;
					this.$axios.put(api, sanitizedItem).then(res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "updated",
							message : this.$ml.get("permissions"),
						});
						this.loading_dev = false;
						this.$store.commit("auth/update_permission", sanitizedItem);

					}).catch(err => {
						console.warn("Error update permisions ", err);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						});
						this.loading_dev = false;

					})

				}else{
					if (this.btn_action == "update" && this.info && this.info.id && item && item.name) {
						this.create_permission_for_role(item);
						return;
					}

					console.warn("required id to update ", item);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("req_id_to_update"),
					})
				}
			}, // update permission
			delete_permission(item){
				if (item && item.id) {
					const api = this.$URL + "/api/v1/permission/" + item.id;
					this.loading_dev = true;
					this.$axios.delete(api).then(res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "deleted",
							message : this.$ml.get("permissions"),
						});
						this.loading_dev = false;
						this.$store.commit("auth/delete_permission", item);
						let idx = this.list_permissions.findIndex(x => (x && x.id == item.id));
						if (idx >= 0) {
							this.list_permissions.splice(idx, 1);
						}
						

					}).catch(err => {
						console.warn("Error delete permisions ", err);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						});
						this.loading_dev = false;

					})

				}else{
					console.warn("required id to delete ", item);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("req_id_del"),
					})
				}
			}, // update permission

			save_unlited_permissions(){
				if (this.info && this.info.id) {
					this.$store.dispatch("auth/diff_permissions", {
						permissions : [ ...this.list_permissions ],
					}).then(resp => {
						
						console.log("res add_unlisted_permissions ", resp )
						if (resp && resp.length > 0) {
							this.loading_dev 				= true;
							this.show.unlisted_permissions 	= false;

							const api = this.$URL + "/api/v1/permission";
							resp.forEach(async (per, idx, len) => {

								let info_up = {
				                  name        : per.name,
				                  roleId 	  : this.info.id,
				                  resourceId  : per.id,
				                  can_add     : false,
				                  can_view    : true, 
				                  can_edit    : true,
				                  can_delete  : false,
				                }

				                await this.$axios.post(api, info_up).then(res =>{
				                	if (res && res.data) {
				                		this.list_permissions.push({ ...res.data });
				                	}
				                	if (idx == len.length - 1 ) {
										this.loading_dev 				= false;
										this.show.unlisted_permissions 	= true;

										this.$EventBus.$emit("notifications_modal",{
											type  	: "saved",									
										});
									}
				                }).catch(err => {
				                	console.warn("Error create permission ", err);
				                	if (idx == len.length - 1 ) {
										this.loading_dev 				= false;
										this.show.unlisted_permissions 	= true;
									}
				                })
							})
						}else{
							// this.show.unlisted_permissions = false;
							this.$EventBus.$emit("notifications_modal",{
								type  	: "success",
								message : this.$ml.get("not_found_items_add")									
							})
						}
					});
					
					

				}else{
					console.warn("Required id to update ", this.info);
					this.$EventBus.$emit("notifications_modal",{
						type  	: "warning",
						message : this.$ml.get("req_id_to_update_list"),									
					})
				}
			}, // 

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					if (this.info_item && this.info_item.item && this.info_item.action == "delete_permission"){
						this.delete_permission(this.info_item.item);
					}else{
						this.del(this.info_item);
					}
				}
			}); 
			temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								// console.log("obj key ", this[obj][key], action.input)
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});
			temp_bus = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on( temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								console.log("SEARCH EVENT")
								// this.get_search(this.search);
							}

						}
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'integration_cloud');

		}, // beforeDestroy

	}; // export default
</script>

<style scoped>
.permission-matrix ::v-deep .v-data-table__wrapper {
	background: #1f1f1f;
}

.permission-matrix ::v-deep th:first-child,
.permission-matrix ::v-deep td:first-child {
	min-width: 280px;
}

.permission-matrix ::v-deep th:not(:first-child),
.permission-matrix ::v-deep td:not(:first-child) {
	min-width: 86px;
	text-align: center;
}

.permission-module-row {
	position: sticky;
	left: 0;
	z-index: 2;
}

.permission-module-row__title {
	font-size: 0.9rem;
}

.permission-suboption {
	border-left: 2px solid rgba(144, 202, 249, 0.45);
	margin-left: 14px;
	padding-left: 12px;
}

.permission-suboption__title {
	line-height: 1.25;
}

.permission-suboption__description {
	line-height: 1.35;
	white-space: normal;
}

.permission-toggle--disabled {
	opacity: 0.55;
}
</style>
